import thickElement from "../../../../images/silver-icon/thick-element.png";
import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component("forecastConfigEdit", {
        template: require("./forecastConfigEditComponent.html"),
        bindings: {
            options: "="
        },
        controller: [
            "$scope",
            "AlertService",
            angularServicesNames.$uibModal,
            angularServicesNames.$translate,
            AgGridService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                AlertService: AlertService,
                $uibModal: ng.ui.bootstrap.IModalService,
                $translate: ng.translate.ITranslateService,
                agGridService: AgGridService
            ) {
                var $ctrl = this;
                $scope.model = {};

                $scope.$on("LanguageChanged", () => {
                    if ($ctrl.gridApi) {
                        agGridService.refreshGridLanguage($ctrl.gridApi);
                    }
                });

                $ctrl.gridOptions = {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.FORECAST.NAME"),
                            field: "name"
                        },
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.FORECAST.VALUE"),
                            field: "value",
                            cellRenderer: (params: $TSFixMe) =>
                                `<div class="ui-grid-cell-contents"><span>${params.data.value}%</span></div>`
                        },
                        {
                            field: "isActive",
                            headerValueGetter: () => $translate.instant("CONFIGURATION.FORECAST.IS_ACTIVE"),
                            cellRenderer: () =>
                                `<div class="ui-grid-cell-contents"><span ng-class="{\'invisible\': data.isActive == 0 }" class="element-icon positive"><img src="${thickElement}"><span></div>`
                        },
                        {
                            headerValueGetter: () => $translate.instant("ACTIONS"),
                            cellRenderer: (params: $TSFixMe) => `<div  class="ui-grid-cell-contents">
                             <a href="#" ng-click="$ctrl.actions.edit(data)"><i class="glyphicon glyphicon-edit"></i></a>
                             <a ng-class="{\'invisible\': ${params.data.isActive} == 0}" href="#" ng-click="$ctrl.actions.deactivate(data)"><i class="glyphicon deactivate-icon glyphicon-remove-circle"></i></a>
                             </div>`,
                            width: 90,
                            filter: false,
                            sortable: false,
                            suppressMenu: true
                        }
                    ],
                    domLayout: "autoHeight",
                    angularCompileRows: true,
                    defaultColDef: {
                        sortable: true,
                        resizable: true
                    },
                    enableFilter: false,
                    animateRows: true,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        loadData();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                };

                $ctrl.actions = {
                    edit: function (entity: $TSFixMe) {
                        var modalInstance = $uibModal.open({
                            component: "forecastNameValueEdit",
                            resolve: {
                                model: mapEntity(entity, entity.isActive),
                                options: $ctrl.options
                            }
                        });
                        modalInstance.result.then(function (result: $TSFixMe) {
                            editEntity(result);
                        });
                    },
                    add: function () {
                        processCallback("add", { name: $scope.model.name, value: $scope.model.value });
                    },
                    deactivate: function (entity: $TSFixMe) {
                        editEntity(mapEntity(entity, false));
                    }
                };

                function mapEntity(entity: $TSFixMe, isActiveFlag: $TSFixMe) {
                    return {
                        id: entity.id,
                        name: entity.name,
                        value: entity.value,
                        isActive: isActiveFlag
                    };
                }

                function editEntity(entity: $TSFixMe) {
                    processCallback("edit", entity);
                }

                function loadData() {
                    $ctrl.options.dataProvider().then(function (data: $TSFixMe) {
                        if ($ctrl.gridApi) {
                            $ctrl.gridApi.setRowData(data.items);
                        }
                    });
                }

                function processCallback(callbackName: $TSFixMe, entity: $TSFixMe) {
                    function processCallbackInternal(callback: $TSFixMe) {
                        callback
                            .then((response: $TSFixMe) => {
                                if (response.status == HttpStatus.OK || response.status == 204) {
                                    loadData();

                                    $scope.model = {};
                                    $scope.editForm.$setPristine();
                                    $scope.editForm.$setUntouched();

                                    AlertService.success($translate.instant("CONFIGURATION.FORECAST.SUCCESS"));
                                } else {
                                    errorHandler(response);
                                }
                            })
                            .catch(function (error: $TSFixMe) {
                                AlertService.error(error);
                            });
                    }

                    if ($ctrl.options.callbacks && $ctrl.options.callbacks[callbackName]) {
                        var callback = $ctrl.options.callbacks.edit(entity);
                        processCallbackInternal(callback);
                    }
                }

                const errorHandler = (err: $TSFixMe) => {
                    switch (err.status) {
                        case HttpStatus.Conflict:
                            AlertService.error($translate.instant("CONFIGURATION.FORECAST.RISK_NAME_NOT_UNIQUE"));
                            break;
                        case HttpStatus.NotAcceptable:
                            AlertService.error($translate.instant("CONFIGURATION.FORECAST.RISK_VALUE_INVALID"));
                            break;
                    }
                };
            }
        ]
    });
})(angular.module("topline.modules"));
